import React,{useState,useEffect} from 'react'
import { useAuth } from '../../context/AuthContext'
import { Link, NavLink, useNavigate } from 'react-router-dom'
import { AccountBalance, AccountCircle, Announcement, BookOnline, Business,Menu, CalendarMonthOutlined, Campaign, Category, Chat, Dashboard, DataObject, DoorSliding, Dvr, FollowTheSigns, Groups3, Home,  Label,  ListAlt,  ManageAccounts, MenuOpen, MoreVert, Newspaper, NoteAdd, Notifications, PhoneAndroid, PsychologyAlt, Quiz, ReplyAll, Settings, Store, Tablet, TransferWithinAStation, Tv, WorkOutlined, DocumentScanner} from '@mui/icons-material';
import useBusinessInfo from '../../hooks/useBusinessInfo';
import { Alert, } from '@mui/material';
import moment from 'moment';
import { useAppData } from '../../context/AppDataContext';
import CompanySelector from '../components/CompanySelector';

function AdminHeader() {

    const {authUser } = useAuth();
    const businessInfo = useBusinessInfo();

    const navigate = useNavigate();
    useEffect(()=>{
        if(businessInfo?.accountStatus === false){
          navigate("/admin/suspend-page");
        }
    },[businessInfo])

    return (
        <>
        {businessInfo?.pendingDays < 15 &&
            <div className="">
                <div className='text-danger text-center'> Your Account will suspend on { moment(businessInfo.validTill).format("ll")} please recharge asap</div>
            </div>
        }
        <nav className="navbar navbar-expand-lg navbar-light bg-light sticky-top shadow mb-3">
            <div className="container-fluid">
                <Link className="me-5" to="/">
                    <img src='/erp.png' style={{height:40}} />
                    {/* <img className="ms-2" src='/images/whatsapp.png' style={{height:40}} /> */}
                </Link> {/* navbar-brand  */}
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#collapsibleNavbar">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="collapsibleNavbar">
                    { authUser.role <= 2 && 
                    <ul className="navbar-nav me-auto mb-2 mb-lg-0" style={{fontSize:"18px"}}>
                        <li className="nav-item"><NavLink className="nav-link text-center" to="/"> <Home/> Home</NavLink></li>
                        <li className="nav-item"><NavLink className="nav-link text-center" to="/finance/dashboard"><AccountBalance/>Accounting</NavLink></li>


                        <li className="nav-item dropdown">
                            <NavLink className="nav-link dropdown-toggle"  role="button" data-bs-toggle="dropdown"><Groups3/> CRM</NavLink>
                            <ul className="dropdown-menu">
                                <li><NavLink className="dropdown-item" to="/customer/list">Manage Customer</NavLink></li>
                                <li><NavLink className="dropdown-item" to="/grievance/dashboard">Complaints / Grievance</NavLink></li>
                                <li><NavLink className="dropdown-item" to="/lead/dashboard">Leads</NavLink></li>
                                <li><NavLink className="dropdown-item" to="/tender/dashboard">Manage Tender</NavLink></li>
                                <li><NavLink className="dropdown-item" to="/proposal/list">Proposal / Quotation</NavLink></li>
                                <li><NavLink className="dropdown-item" to="/crm/terms-template">Terms Templates</NavLink></li>
                                <li><NavLink className="dropdown-item" to="/crm/document-template">Documents</NavLink></li>
                            </ul>
                        </li>

                        

                        <li className="nav-item dropdown">
                            <NavLink className="nav-link dropdown-toggle" to="/employee"  role="button" data-bs-toggle="dropdown"><Category/> HRMS</NavLink>
                            <ul className="dropdown-menu">
                                
                                <li><NavLink className="dropdown-item" to="/hrms/company/dashboard">Manage Company</NavLink></li>
                                <li><NavLink className="dropdown-item" to="/hrms/company/location">Manage Company Location</NavLink></li>
                                <li><NavLink className="dropdown-item" to="/project/dashboard">Manage Projects</NavLink></li>
                                <li><NavLink className="dropdown-item" to="/task/dashboard">Manage Task</NavLink></li>
                                <li><NavLink className="dropdown-item" to="/employee/dashboard">Manage Employee</NavLink></li>
                                <li><NavLink className="dropdown-item" to="/attendance/dashboard">Attendance</NavLink></li>
                                <li><NavLink className="dropdown-item" to="/leave-request/dashboard">Leave Request</NavLink></li>
                                <li><NavLink className="dropdown-item" to="/work-report/dashboard">Work Report</NavLink></li>
                                <li><NavLink className="dropdown-item" to="/holiday-list/dashboard">Holiday List</NavLink></li>
                                <li><NavLink className="dropdown-item" to="/employee/print-id-card">Print ID Card</NavLink></li>
                            </ul>
                        </li>

                        <li className="nav-item dropdown">
                            <NavLink className="nav-link dropdown-toggle" to="/fms"  role="button" data-bs-toggle="dropdown"><DocumentScanner /> FMS</NavLink>
                            <ul className="dropdown-menu">
                                
                                <li><NavLink className="dropdown-item" to={"/fms/document-dashboard"} >Dashboard</NavLink></li>
                                <li><NavLink className="dropdown-item" to={"/fms/barcode-list"} >Barcodes</NavLink></li>
                                
                                <li><NavLink className="dropdown-item" to={"/fms/document-list"} >Document List</NavLink></li>
                                <li><NavLink className="dropdown-item" to={"/fms/search"} >Document Search</NavLink></li>
                            </ul>
                        </li>

                    </ul>
                    }
                    {/* Just for Alignment  */}
                    { authUser.role > 2 &&
                        <div className=" me-auto "></div>
                    } 
                    
                    <div className=" ">
                        <CompanySelector />
                    </div>

                        <ul className="navbar-nav">
                            { authUser.role <= 2 && 
                            <li className="nav-item dropdown">
                                <a className="nav-link" href="!#" id="adminControllDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false"> <MoreVert/> </a>
                                <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="adminControllDropdown">
                                    <li><NavLink className="dropdown-item" to="/master/list"><Label /> Status Master</NavLink></li>
                                    <li><NavLink className="dropdown-item" to="/business/details"><WorkOutlined/> Business Details</NavLink></li>
                                    <li><NavLink className="dropdown-item" to="/user/list"><ManageAccounts/> Manage User Accounts</NavLink></li>
                                    <li><NavLink className="dropdown-item" to="/user/role"><Settings/> Manage User Role</NavLink></li>
                                </ul>
                            </li>
                            }



                            <li className="nav-item dropdown">
                                <a className="btn btn-danger" style={{borderRadius:"50px"}} href="!#" id="userDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false"> 
                                    {authUser.firstName.charAt(0).toUpperCase()}
                                </a>
                                <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="userDropdown">
                                    {/*<li><a className="dropdown-item" href="/auth/change-password">Change Password</a></li> */}
                                    <li><hr className="dropdown-divider"/></li>
                                    <li><NavLink className="dropdown-item" to="/auth/logout">Logout</NavLink></li>
                                </ul>
                            </li>
                        </ul>
                </div>
            </div>
        </nav>
        </>
    )
}

export default AdminHeader